/* Woodcraftees — instant colour-swatch image swap (Globo-speed on native Dawn).
 *
 * WHY: this theme's gallery renders only the SELECTED variant's image, so Dawn does a full section
 * round-trip on every colour change just to fetch the new image — visibly laggy on mobile (Globo swapped
 * the <img src> client-side, instantly). This restores that snappiness.
 *
 * WHAT: on a colour-swatch tap we optimistically point the visible product <img> at that colour's
 * featured_image (mapped from /products/<handle>.js, cached; warmed on pointer-down so it's already loaded).
 * Dawn's own fetch still runs and does the authoritative update (price/form/media) a moment later — this
 * only changes what's shown DURING that window. IMAGE ONLY: never touches price, variant, or cart, so it
 * cannot affect correctness. Any failure = today's behaviour (Dawn's fetch handles it). */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;
  var handle = location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split(/[/?#]/)[0];

  var colorMap = null;   // colour(lower) -> featured_image.src

  function sized(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900'; }
  function colorFromLabel(lbl) {
    var input = document.getElementById(lbl.getAttribute('for')) || lbl.previousElementSibling;
    return input && input.value ? input.value.trim().toLowerCase() : null;
  }
  function mainImg() {
    var g = document.querySelector('media-gallery');
    if (!g) return null;
    return g.querySelector('.product__media-item.is-active img')
        || g.querySelector('.product__media-item img')
        || g.querySelector('img');
  }
  function swapTo(color) {
    if (!colorMap) return;
    var src = colorMap[color];
    if (!src) return;
    var img = mainImg();
    if (!img) return;
    var fname = src.split('?')[0].split('/').pop();
    if ((img.currentSrc || img.src || '').indexOf(fname) > -1) return; // already this colour
    img.setAttribute('srcset', '');   // neutralise the responsive candidates so `src` wins
    img.setAttribute('sizes', '');
    img.src = sized(src);
  }

  // Warm the image on pointer-down (fires ~100-200ms before the click) -> the swap is then instant.
  document.addEventListener('pointerdown', function (e) {
    if (!colorMap || !e.target.closest) return;
    var lbl = e.target.closest('fieldset.product-form__input--swatch label');
    if (!lbl) return;
    var color = colorFromLabel(lbl);
    if (color && colorMap[color]) { var im = new Image(); im.src = sized(colorMap[color]); }
  }, true);

  // On the actual tap, swap the visible image immediately (Dawn's fetch still runs behind it).
  document.addEventListener('click', function (e) {
    if (!colorMap || !e.target.closest) return;
    var lbl = e.target.closest('fieldset.product-form__input--swatch label');
    if (!lbl) return;
    var color = colorFromLabel(lbl);
    if (color) requestAnimationFrame(function () { swapTo(color); });
  }, true);

  fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      var m = {};
      p.variants.forEach(function (v) {
        var c = (((v.public_title || '').split(' / ')[0]) || '').trim().toLowerCase();
        if (c && !m[c] && v.featured_image && v.featured_image.src) m[c] = v.featured_image.src;
      });
      colorMap = m;
    })
    .catch(function () {});
})();
